/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BuchungscodeDto } from '../../models/buchungscode-dto';

export interface GetAllBuchungscodes$Plain$Params {
}

export function getAllBuchungscodes$Plain(http: HttpClient, rootUrl: string, params?: GetAllBuchungscodes$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<BuchungscodeDto>>> {
  const rb = new RequestBuilder(rootUrl, getAllBuchungscodes$Plain.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<BuchungscodeDto>>;
    })
  );
}

getAllBuchungscodes$Plain.PATH = '/v1/buchungscodes';
